import "./App.css";
import { Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";
import DataUploader from "./components/DataUploader/DataUploader";
import ProtectedRoutes from "./utils/ProtectedRoutes";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import CompanyTable from "./components/Table/CompanyTable";
import CampaignTable from "./components/Table/CampaignTable";
import InfluencerTable from "./components/Table/InfluencerTable";
import UserTable from "./components/Table/UserTable";
import ProspectTable from "./components/Table/ProspectTable";
import { EmailAccounts } from "./components/EmailAccounts/EmailAccounts";
import { Sequences } from "./components/Sequences/Sequences";
import { NewSequences } from "./components/Sequences/NewSequences";
import { Navigate } from "react-router-dom";
import InboxTable from "./components/Table/InboxTable";
import TestBord from "./components/Table/TestBord";
import { FaRegMessage } from "react-icons/fa6";
import InfluencerDealsTable from "./components/Table/InfluencerDealsTable"; //Added by me......
import ViewDeals from "./components/Table/ViewDeals";
import Contract from "./components/Table/Contract";
import DealsTab from "./components/Table/DealsTab";
import AllDealsTab from "./components/Table/AllDealsTab";
import CreatorManager from "./pages/CreatorManager";
import Influencerlog from "./pages/Influencerlog";
import Profile from "./components/Table/Profile";
import Scouting from "./components/Table/Scouting";
import InboxAllEmails from "./components/Table/InboxAllEmails";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import { InfluencerSequences } from "./components/Sequences/InfluencerSequences";
import HomePage from "./pages/Home/HomePage";
import CreatorCard from "./pages/roster/roster";
import SashaChatbot from "./components/sashabot/SashaBot.js";
import Draggable from "react-draggable";

import React, { useEffect, useState } from "react";

const creatorName = localStorage.getItem("userName") || "Creator";
const hasInteracted = localStorage.getItem("hasInteractedWithBot") === "true";

const routesConfig = [
  {
    path: "/admin",
    component: AdminPage,
    role: "Admin",
  },
  {
    path: "/creator",
    component: CreatorManager,
    role: "Creator Manager",
  },
  {
    path: "/influencer",
    component: Influencerlog,
    role: "Influencer",
  },
];

function App() {
  const token = localStorage.getItem("token"); // <-- Add this line
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewContent, setReviewContent] = useState("");

  const [showBot, setShowBot] = useState(false);
  const [hasInteractedWithBot, setHasInteractedWithBot] = useState(
    localStorage.getItem("hasInteractedWithBot") === "true"
  );

  const location = useLocation();

  let auth = localStorage.getItem("userEmail");

  const role = localStorage.getItem("Role") || location.state?.role;

  let routeConfig;

  switch (role) {
    case "Admin":
      routeConfig = routesConfig.find((route) => route.role === "Admin");
      break;
    case "Creator Manager":
      routeConfig = routesConfig.find(
        (route) => route.role === "Creator Manager"
      );
      break;
    case "Influencer":
      routeConfig = routesConfig.find((route) => route.role === "Influencer");
      break;
    default:
      routeConfig = { path: "/", component: HomePage };
  }

  useEffect(() => {
    // Auto-open bot on first login only
    if (!hasInteracted) {
      setShowBot(true);
    }
  }, [hasInteracted]);

  return (
    <>
      <Routes>
        <Route exact path="/roster" element={<CreatorCard />} />
        <Route
          exact
          path="/"
          element={
            !role && !auth ? (
              <HomePage />
            ) : (
              <Navigate to={`${routeConfig.path}/dashboard`} />
            )
          }
        />

        <Route
          exact
          path="/login"
          element={
            !role && !auth ? (
              <LoginPage />
            ) : (
              <Navigate to={`${routeConfig.path}/dashboard`} />
            )
          }
        />
        <Route
          exact
          path={routeConfig.path}
          element={
            !role && !auth ? (
              <Navigate to={`/`} />
            ) : (
              <Navigate to={`${routeConfig.path}/dashboard`} />
            )
          }
        />

        <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/terms-of-service" element={<TermsOfService />} />

        {auth && (
          <Route
            key={0}
            path={routeConfig.path}
            element={
              <ProtectedRoutes
                mainPath={routeConfig.path}
                component={routeConfig.component}
                role={routeConfig.role}
              />
            }
          >
            <Route exact path="dashboard" element={<TestBord />} />
            <Route exact path="uploader" element={<DataUploader />} />
            <Route exact path="company" element={<CompanyTable />} />
            <Route exact path="prospect" element={<ProspectTable />} />
            <Route exact path="Outreach" element={<CampaignTable />} />
            <Route exact path="influencer" element={<InfluencerTable />} />
            <Route exact path="accounts" element={<EmailAccounts />} />
            <Route exact path="sequences" element={<Sequences  setGenShowBot={setShowBot}/>} />
            <Route
              exact
              path="influencerSequences"
              element={<InfluencerSequences />}
            />
            <Route exact path="sequences/new" element={<NewSequences />} />
            <Route exact path="users" element={<UserTable />} />
            <Route exact path="deals" element={<DealsTab />} />
            <Route exact path="All_Deals" element={<AllDealsTab />} />
            <Route exact path="Inbox" element={<InboxTable />} />
            <Route
              exact
              path=":talent_name/cm/:id"
              element={<InfluencerDealsTable />}
            />
            <Route exact path=":talent_name/:id" element={<ViewDeals />} />
            <Route exact path="Contract_Review" element={<Contract />} />
            <Route exect path="profile" element={<Profile />} />
            <Route exect path="scouting" element={<Scouting />} />

            <Route
              exect
              path=":currentTalName/Inbox"
              element={<InboxAllEmails />}
            />
          </Route>
        )}

        <Route
          path="*"
          element={
            !auth ? <Navigate to={`/`} /> : <h3>There's nothing here: 404!</h3>
          }
        />
      </Routes>

      {role === "Influencer" && (
        <div className="dashboard-container">
          <div className="sasha-widget-container">
            <button
              className={`sasha-chatbot-toggle ${showBot ? "close" : ""}`}
              onClick={async () => {
                if (showBot) {
                  setShowBot(false);
                  if (!hasInteractedWithBot) {
                    try {
                      const response = await fetch(
                        "https://api.creativesmatter.com/update_interaction/",
                        {
                          method: "GET",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                        }
                      );
                      const data = await response.json();
                      console.log("API response:", response.status, data);
                    } catch (err) {
                      console.error("Failed to update bot status:", err);
                    }
                    localStorage.setItem("hasInteractedWithBot", "true");
                    setHasInteractedWithBot(true);
                  }
                } else {
                  setShowBot(true);
                }
              }}
            >
              {showBot ? "x" : <FaRegMessage size={20} />}
            </button>

            {showBot && (
              <Draggable handle=".sasha-chatbox-header" bounds="parent">
                <div className="sasha-chatbot-wrapper">
                  <SashaChatbot
                    creatorName={creatorName}
                    hasInteractedWithBot={hasInteractedWithBot}
                    onClose={() => setShowBot(false)}
                    setReviewContent={setReviewContent}
                    setShowReviewModal={setShowReviewModal}
                  />
                </div>
              </Draggable>
            )}
          </div>
        </div>
      )}
      {/* ✅ Place modal OUTSIDE SashaChatbot here */}
      {showReviewModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="contract-inner">
              <div className="contract-header">
            <button
              className="modal-close"
              onClick={() => setShowReviewModal(false)}
            >
              &times;
            </button>
            <h2>Contract Review</h2>
            </div>
            <div className="contract-body">
              <div
                className="formatted-review"
                dangerouslySetInnerHTML={{
                  __html: reviewContent
                    .replace(/\n/g, "<br>")
                    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>"),
                }}
              />
            </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
